import { CancelToken } from 'axios';
import { agpAxiosClient } from './ABHubTokenConfig';

export interface ChatResponse {
    reply: string;
    tool?: string;
    data?: unknown;
}

export const sendChat = async (
    prompt: string,
    cancelToken?: CancelToken
): Promise<ChatResponse> => {
    const response = await agpAxiosClient.post<ChatResponse>(
        `api/chat`,
        { prompt },
        { cancelToken }
    );
    return response.data;
};
